import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface TransferResult {
  fromAddress: string;
  toAddress: string;
  amount: string;
  fromChain: string;
  toChain: string;
  transferId: string;
  userId: string;
  jobId: string;
  status: string;
}

export const useTransferMutation = () =>
  useMutation({
    mutationFn: async (params: {
      fromAddress: string;
      toAddress: string;
      amount: string;
      fromChain: string;
      toChain: string;
      transferId: string;
      userId: string;
    }) => {
      return await apiClient('/api/v2/transfers', {
        method: 'POST',
        body: params,
      });
    },
  });
